(function() {
	'use strict';

	angular
		.module('cacmDynamicsAccountTransactionModule', []);
})();